import { useEffect, useState } from 'react';
import { api } from '../api';

const emptyForm = { info_key: '', info_label: '', info_value: '', sort_order: 0 };

export default function InformationPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);

  const load = () => api.information.list().then(setItems).catch((error) => alert(error.message));

  useEffect(() => { load(); }, []);

  const submit = (event) => {
    event.preventDefault();
    api.information.save(editId, form)
      .then(() => { setForm(emptyForm); setEditId(null); load(); })
      .catch((error) => alert(error.response?.data?.message || error.message));
  };

  return (
    <>
      <h2>회사정보</h2>
      <form onSubmit={submit}>
        <input placeholder="info_key (company_name)" value={form.info_key} onChange={(e) => setForm({ ...form, info_key: e.target.value })} required />
        <input placeholder="표시명" value={form.info_label} onChange={(e) => setForm({ ...form, info_label: e.target.value })} required />
        <textarea placeholder="값" value={form.info_value} onChange={(e) => setForm({ ...form, info_value: e.target.value })} required />
        <div className="row">
          <button type="submit">{editId ? '수정' : '추가'}</button>
          <button type="button" className="ghost" onClick={() => { setForm(emptyForm); setEditId(null); }}>취소</button>
        </div>
      </form>
      <table>
        <thead><tr><th>키</th><th>표시명</th><th>값</th><th></th></tr></thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.information_id}>
              <td>{item.info_key}</td>
              <td>{item.info_label}</td>
              <td>{item.info_value}</td>
              <td className="row">
                <button type="button" onClick={() => { setEditId(item.information_id); setForm(item); }}>수정</button>
                <button type="button" className="danger" onClick={() => window.confirm('삭제할까요?') && api.information.remove(item.information_id).then(load)}>삭제</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
